/**
 * Money formatting.
 *
 * Amounts arrive from the API as decimal *strings* and stay strings until they
 * are displayed - parsing them into JavaScript numbers would introduce binary
 * floating-point error into rupee values.
 *
 * These are the store's rupee shorthands over `lib/i18n/format.ts`, written in
 * the active locale (`en-IN` unless an `I18nProvider` owning the page says
 * otherwise). The currency stays INR whatever the language: a language never
 * decides a currency.
 */
import {
  formatDate as formatLocaleDate,
  formatDateTime as formatLocaleDateTime,
  formatMoney as formatLocaleMoney,
  getActiveLocale,
} from '@/lib/i18n/format';

export function formatMoney(amount: string | number | null | undefined): string {
  return formatLocaleMoney(amount, 'INR', getActiveLocale());
}

export function formatDate(iso: string | null | undefined): string {
  return formatLocaleDate(iso, getActiveLocale());
}

export function formatDateTime(iso: string | null | undefined): string {
  return formatLocaleDateTime(iso, getActiveLocale());
}
